import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PRODUCTS_SERVICE_URL } from 'src/app/injection-tokens';
import { map, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Stats } from '../suppliers/supplier';
import { FestoSpecial } from './festo-special';

export interface FestoCombinedData {
  specials: FestoSpecial[];
  stats: Stats;
}

@Injectable({
  providedIn: 'root',
})
export class FestoSpecialsService {
  readonly serviceURL: string;

  constructor(
    @Inject(PRODUCTS_SERVICE_URL) readonly baseServiceURL: string,
    readonly http: HttpClient
  ) {
    this.serviceURL = baseServiceURL + '/specials';
  }

  getCombinedData(): Observable<FestoCombinedData> {
    // Sequential on purpose: Firefox aborts parallel requests to the VPN-only API hosts,
    // see "Parallel requests to private API hosts" in AGENTS.md.
    return this.getFestoSpecials().pipe(
      switchMap(specials => this.getFestoStats().pipe(map(stats => ({ specials, stats }))))
    );
  }

  createFestoSpecial(festoSpecial: FestoSpecial): Observable<FestoSpecial> {
    return this.http.post<FestoSpecial>(this.serviceURL + '/festo', festoSpecial);
  }

  getFestoSpecial(id: number): Observable<FestoSpecial> {
    return this.http.get<FestoSpecial>(`${this.serviceURL}/festo/${id.toString()}`);
  }

  getFestoStats(): Observable<Stats> {
    return this.http.get<Stats>(`${this.serviceURL}/festo/stats`);
  }

  getFestoSpecials(): Observable<FestoSpecial[]> {
    return this.http.get<FestoSpecial[]>(this.serviceURL + '/festo');
  }
}
